import { ApiHelper } from './apiHelper';

export class UserManagerApi {
    sendUserVerificationEmail(
        userId,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        var url = '/api/user/verifyemail';
        new ApiHelper().postDataWithResponseSecure(
            url,
            {
                userId: userId
            },
            token,
            successCallback,
            failureCallback
        );
    }
}
